import { compose, find, prop, propEq, sortBy, toLower } from 'ramda'
import us from 'us'

// @ts-ignore: ramda typing error
const sortByValue = sortBy(compose(toLower, prop('value')))

interface State {
  label: string
  value: string
}

const MILITARY_TERRITORIES: State[] = [
  {
    label: 'AA',
    value: 'Armed Forces America',
  },
  {
    label: 'AE',
    value: 'Armed Forces Europe',
  },
  {
    label: 'AP',
    value: 'Armed Forces Pacific',
  },
  {
    label: 'PR',
    value: 'Puerto Rico',
  },
  {
    label: 'GU',
    value: 'Guam',
  },
  {
    label: 'VI',
    value: 'Virgin Islands',
  },
]

const US_STATES: State[] = us.STATES.map(({ abbr, name }) => ({
  label: abbr,
  value: name,
}))

const STATES = Object.freeze(
  sortByValue([...MILITARY_TERRITORIES, ...US_STATES]),
) as State[]

export const NORMALIZED_STATES = Object.freeze(
  STATES.map(({ label, value }) => {
    return {
      label,
      value: value.toLowerCase(),
    }
  }),
) as State[]

export const getStateAbbreviation = (
  state = '',
): State['label'] | undefined => {
  const value = find<State>(propEq('value', state.toLowerCase()))(
    NORMALIZED_STATES,
  )

  return value?.label
}

export default STATES
